import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { selectCurrency } from "../../../features/user/userSlice";
import { formatNumber } from "../../../utils/tools";
import { Button, ButtonsContainerRetiro, ErrorSpan, Form, InputContainer } from "../DepositElements";
import monnetpasarelas from '../../../assets/images/chileRetiro1.png';
import perupasarelas from '../../../assets/images/peruRetiro1.png';
import ecuadorpasarelas from '../../../assets/images/ecuadorRetiro1.png';
import RetiraMonnet from '../../../assets/images/RETIRACONMONET-01.svg';
import guatemalapasarelas from '../../../assets/images/guatemalaRetiro1.png';


const FormMonnet = ({
  form,
  handleChange,
  handleClose,
  solicitarRetiro,
  loading,
}) => {
  const [t] = useTranslation("global");
  const moneda = useSelector(selectCurrency);
  const [monto, setMonto] = useState(0);
  const [blur, setBlur] = useState(false);

  const handleMonto = (e) => {
    setBlur(true);
    handleChange(formatNumber(e));
    setMonto(parseFloat(e.target.value.replaceAll(".", "").replace(",", ".")));
    if (e.target.value === "") setMonto(0);
  };

  return (
    <Form>
      <InputContainer>
        <label>NOMBRE DEL BANCO:</label>
        <select value={form.bank} onChange={handleChange} name='bank'>
          {moneda === 'CLP' && (
            <>
              {/* Opciones para la moneda CLP */}
              <option disabled value=''>{t("deposit.lbl-bank")}</option>
              <option value='001 - Banco de Chile Edwards'>Banco de Chile - Edwards</option>
              <option value='009 - Banco Internacional'>Banco Internacional</option>
              <option value='012 - Banco Estado (Banco del Estado de Chile)'>Banco Estado (Banco del Estado de Chile)</option>
              <option value='014 - Scotiabank'>Scotiabank</option>
              <option value='016 - BCI (Bco de Credito e Inv)'>BCI (Bco de Credito e Inv)</option>
              <option value='027 - Itau Corpbanca'>Itau-Corpbanca</option>
              <option value='028 - Banco Bice'>Banco Bice</option>
              <option value='031 - Hsbc Bank'>Hsbc Bank</option>
              <option value='037 - Banco Santander'>Banco Santander</option>
              <option value='039 - Itau Chile'>Itau Chile</option>
              <option value='049 - Banco Security'>Banco Security</option>
              <option value='051 - Banco Falabella'>Banco Falabella</option>
              <option value='053 - Banco Ripley'>Banco Ripley</option>
              <option value='055 - Banco Consorcio'>Banco Consorcio</option>
              <option value='057 - Banco Paris'>Banco Paris</option>
              <option value='152 - Prepago Los Heroes'>Prepago Los Heroes</option>
              <option value='504 - BBVA (Bco Bilbao Vizcaya Arg)'>BBVA (Bco Bilbao Vizcaya Arg)</option>
              <option value='507 - Banco del Desarrollo'>Banco del Desarrollo</option>
              <option value='672 - Coopeuch'>Coopeuch</option>
              <option value='730 - Tenpo'>Tenpo</option>
              <option value='732 - Prepago Los Andes'>Prepago Los Andes</option>
              <option value='738 - Global 66'>Global 66</option>
              <option value='875 - MercadoPago'>MercadoPago</option>
              {/* ... */}
            </>
          )}
          {moneda === '$' && (
            <>
              {/* Opciones para la moneda dólar */}
              <option disabled value=''>{t("deposit.lbl-bank")}</option>
              <option value='010 - Banco Pichincha C.A.'>Banco Pichincha C.A</option>
              <option value='017 - Banco de Guayaquil S.A'>Banco de Guayaquil S.A</option>
              <option value='024 - Banco City Bank'>Banco City Bank</option>
              <option value='025 - Banco Machala'>Banco Machala</option>
              <option value='029 - Banco de Loja'>Banco de Loja</option>
              <option value='030 - Banco del Pacifico'>Banco del Pacifico</option>
              <option value='032 - Banco Internacional'>Banco Internacional</option>
              <option value='034 - Banco Amazonas'>Banco Amazonas</option>
              <option value='035 - Banco del Austro'>Banco del Austro</option>
              <option value='036 - Produbanco/Promerica'>Produbanco/Promerica</option>
              <option value='037 - Banco Bolivariano'>Banco Bolivariano</option>
              <option value='039 - Comercial de Manabi'>Comercial de Manabi</option>
              <option value='042 - Banco General Ruminahui S.A.'>Banco General Ruminahui S.A.</option>
              <option value='043 - Banco del Litoral S.A.'>Banco del Litoral S.A.</option>
              <option value='059 - Banco Solidario'>Banco Solidario</option>
              <option value='060 - Banco Procredit S.A'>Banco Procredit S.A</option>
              <option value='061 - Banco Capital'>Banco Capital</option>
              <option value='065 - Banco Desarrollo de Los Pueblos S.A.'>Banco Desarrollo de Los Pueblos S.A.</option>
              <option value='066 - Banecuador B.P.'>Banecuador B.P.</option>
              <option value='201 - Banco Delbank S.A.'>Banco Delbank S.A.</option>
              <option value='213 - Cooperativa de Ahorro y Crédito JEP'>Cooperativa de Ahorro y Crédito JEP</option>
              {/* ... */}
            </>
          )}
          {moneda === 'GTQ' && (
            <>
              {/* Opciones para la moneda GTQ */}
              <option disabled value=''>{t("deposit.lbl-bank")}</option>
              <option value='3901 - BANCO FICOHSA GT'>BANCO FICOHSA GT</option>
              <option value='0101 - BANCO DE GUATEMALA'>BANCO DE GUATEMALA</option>
              <option value='1501 - BANCO INDUSTRIAL'>BANCO INDUSTRIAL</option>
              <option value='4201 - BANCO DE AMERICA CENTRAL S.A.'>BANCO DE AMERICA CENTRAL S.A.</option>
              <option value='4401 - BANCO AGROMERCANTIL S.A.'>BANCO AGROMERCANTIL S.A.</option>
              <option value='3001 - CITIBANK N.A.'>CITIBANK N.A.</option>
              <option value='1901 - BANCO INTERNACIONAL'>BANCO INTERNACIONAL</option>
              <option value='1601 - BANCO BANRURAL'>BANCO BANRURAL</option>
              <option value='1201 - BANCO DE LOS TRABAJADORES'>BANCO DE LOS TRABAJADORES</option>
              <option value='1301 - BANCO INMOBILIARIO'>BANCO INMOBILIARIO</option>
              <option value='4501 - BANCO G&T CONTINENTAL'>BANCO G&T CONTINENTAL</option>
              <option value='0401 - CREDITO HIPOTECARIO NACIONAL'>CREDITO HIPOTECARIO NACIONAL</option>
              <option value='3601 - BANCO VIVIBANCO'>BANCO VIVIBANCO</option>
              <option value='4801 - BANCO INV S.A.'>BANCO INV S.A.</option>
              <option value='4901 - CREDICORP S.A.'>CREDICORP S.A.</option>
              <option value='4101 - BANCO DE ANTIGUA'>BANCO DE ANTIGUA</option>
              <option value='4001 - BANCO PROMERICA S.A.'>BANCO PROMERICA S.A.</option>
              <option value='4701 - BANCO AZTECA'>BANCO AZTECA</option>
              {/* ... */}
            </>
          )}
        </select>
      </InputContainer>

      <InputContainer>
        {moneda === 'Sol' ? (
          <label>{t('deposit.Interbank-account-number(CCI)')}:</label>
        ) : (
          <label>{t('deposit.account-number')}:</label>
        )}
        <input
          type='text'
          placeholder={
            moneda === 'Sol'
              ? t('deposit.Interbank-account-number(CCI)')
              : t('deposit.account-number')
          }
          name='bank_account'
          value={form.bank_account}
          onChange={handleChange}
        />
      </InputContainer>
      <InputContainer>
        <label>{t("deposit.account-type")}:</label>
        <select value={form.account_type} onChange={handleChange} name='account_type' >
          {moneda === '$' && (
            <>
            <option disabled value=''>{t("deposit.select-account-type")}</option>
            <option value='1'>Cuenta Ahorro</option>
            <option value='2'>Cuenta Corriente</option>
            <option value='4'>EFE</option>
            </>
          )}
          {moneda === 'CLP' && (
            <>
            <option disabled value=''>{t("deposit.select-account-type")}</option>
            <option value='1'>Cuenta Ahorro</option>
            <option value='2'>Cuenta Corriente</option>
            <option value='3'>Vista</option>
            <option value='4'>Rut</option>
            <option value='5'>Cuenta Nómina</option>
            </>
          )}

          {moneda === 'GTQ' && (
            <>
            <option disabled value=''>{t("deposit.select-account-type")}</option>
            <option value='1'>Cuenta Monetaria</option>
            <option value='2'>Cuenta Ahorro</option>
            </>
          )}
        </select>
      </InputContainer>

      <InputContainer>
        <label>{t("deposit.documentType")}:</label>
        <select value={form.tipo} onChange={handleChange} name='tipo' >
          {moneda === 'CLP' && (
            <>
              {/* Opciones para la moneda CLP */}
              <option disabled value=''>{t("deposit.select-document-type")}</option>
              <option value='1'>RUT</option>
              <option value='2'>RUN</option>
              <option value='3'>PAS</option>
              <option value='4'>CE</option>
              {/* ... */}
            </>
          )}
          {moneda === '$' && (
            <>
              {/* Opciones para la moneda dólar */}
              <option disabled value=''>{t("deposit.select-document-type")}</option>
              <option value='1'>CEDULA</option>
              <option value='2'>PAS</option>
              <option value='3'>RUC</option>
              {/* ... */}
            </>
          )}

          {moneda === 'GTQ' && (
            <>
              {/* Opciones para la moneda GTQ */}
              <option disabled value=''>{t("deposit.select-document-type")}</option>
              <option value='1'>DPI</option>
              <option value='2'>NIT</option>
              {/* ... */}
            </>
          )}
        </select>
      </InputContainer>

      {moneda === 'CLP' && (form.tipo === '1' || form.tipo === '2') && (
        <InputContainer>
          <label>{t("deposit.id")}</label>
          <div style={{ display: "flex", alignItems: "center" }}>
            <input
              type="text"
              placeholder={t("deposit.id")}
              name="cedula"
              value={form.cedula}
              onChange={handleChange}
              style={{ width: "68%", marginRight: "5px" }}
            />
            <span style={{ margin: "0 5px" }}>-</span>
            <input
              type="text"
              placeholder={t("deposit.letter")}
              name="letra"
              value={form.letra}
              onChange={handleChange}
              style={{ width: "40%" }}
            />
          </div>
        </InputContainer>
      )}

      {moneda === 'CLP' && !(form.tipo === '1' || form.tipo === '2') && (
        <InputContainer>
          <label>{t("deposit.id")}</label>
          <input
            type="text"
            placeholder={t("deposit.id")}
            name="cedula"
            value={form.cedula}
            onChange={handleChange}
          />
        </InputContainer>
      )}

      {moneda === '$' && (
        <InputContainer>
          <label>{t("deposit.id")}</label>
          <input
            type="text"
            placeholder={t("deposit.id")}
            name="cedula"
            value={form.cedula}
            onChange={handleChange}
          />
        </InputContainer>
      )}

      {moneda === 'GTQ' && (
        <InputContainer>
          <label>{t("deposit.id")}</label>
          <input
            type="text"
            placeholder={t("deposit.id")}
            name="cedula"
            value={form.cedula}
            onChange={handleChange}
          />
        </InputContainer>
      )}

      <InputContainer>
        <label>{t("deposit.lbl-amount")}</label>
        <input
          type="text"
          placeholder="0,00"
          name="monto"
          value={form.monto}
          onChange={(e) => handleMonto(e)}
        />
        {moneda === 'CLP' && monto < 20000 && blur && (
          <ErrorSpan>
            {t("deposit.amount-greater-than")} 20.000 {moneda}{" "}
          </ErrorSpan>
        )}
        {moneda === 'CLP' && monto > 10000000 && blur && (
          <ErrorSpan>
            {t("deposit.amount-less-than")} 10.000.000 {moneda}{" "}
          </ErrorSpan>
        )}


        {moneda === '$' && monto < 50 && blur && (
          <ErrorSpan>
            {t("deposit.amount-greater-than")} {moneda}50{" "}
          </ErrorSpan>
        )}
        {moneda === '$' && monto > 5000 && blur && (
          <ErrorSpan>
            {t("deposit.amount-less-than")} {moneda}5.000{" "}
          </ErrorSpan>
        )}

        {moneda === 'GTQ' && monto < 400 && blur && (
          <ErrorSpan>
            {t("deposit.amount-greater-than")} 400 {moneda}{" "}
          </ErrorSpan>
        )}
        {moneda === 'GTQ' && monto > 20000 && blur && (
          <ErrorSpan>
            {t("deposit.amount-less-than")} 20.000 {moneda}{" "}
          </ErrorSpan>
        )}
      </InputContainer>
      <img src={RetiraMonnet} alt='RetiraMonnet' className={'tupa1'} style={{width:'40%', marginLeft: '30%', marginTop: '5%'}}/>
      {moneda === 'CLP' && (
        <img src={monnetpasarelas} alt='Pasarelas Monnet' className={'monnet'} style={{width:'100%', marginTop: '0.5%', marginLeft: '-1%'}}/>
      )}
      {moneda === '$' && (
        <img src={ecuadorpasarelas} alt='Pasarelas Monnet' className={'monnet'} style={{width:'100%', marginTop: '0.5%', marginLeft: '-1%'}}/>
      )}

      {moneda === 'GTQ' && (
        <img src={guatemalapasarelas} alt='Pasarelas Monnet' className={'guatemalaRetiro'} style={{width:'100%', marginTop: '0.5%', marginLeft: '-1%'}}/>
      )}
      <ButtonsContainerRetiro style={{marginTop:'-160px'}}>
        <Button
          onClick={(e) => {
            e.preventDefault();
            handleClose();
          }}
        >
          {t("deposit.btn-cancel")}
        </Button>
        <Button
          primary={true}
          disabled={loading || (monto < 20000 && moneda === 'CLP') || (monto > 10000000 && moneda === 'CLP') || (monto < 50 && moneda === '$') || (monto > 5000 && moneda === '$')
          || (monto < 400 && moneda === 'GTQ') || (monto > 20000 && moneda === 'GTQ')}
          onClick={solicitarRetiro}
        >
          {loading ? t("deposit.loading") : t("deposit.btn-confirm")}
        </Button>
      </ButtonsContainerRetiro>
    </Form>
  );
};

export default FormMonnet;
